// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber8 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M15.536 14.214c0-1.218-.658-2.1-1.778-2.59v-.014c.812-.448 1.372-1.134 1.372-2.226 0-1.47-1.204-2.59-3.122-2.59s-3.122 1.12-3.122 2.59c0 1.092.56 1.778 1.372 2.226v.014c-1.12.49-1.778 1.372-1.778 2.59 0 1.806 1.428 3.01 3.528 3.01s3.528-1.204 3.528-3.01m-3.528-5.978c.91 0 1.47.56 1.47 1.344 0 .756-.56 1.358-1.47 1.358s-1.47-.602-1.47-1.358c0-.77.546-1.344 1.47-1.344m1.764 5.852c0 .966-.686 1.694-1.764 1.694-1.106 0-1.778-.742-1.778-1.694 0-1.008.7-1.722 1.778-1.722 1.064 0 1.764.714 1.764 1.722" />
  );
export default SvgIconNumber8;
